import {type CardEnum, type CardStateOrdered, type CardStateUnordered, type CardTypeEnum} from '@colonist/game-states'
import {ArrayUtils} from '@colonist/utils'
import {CardDataController} from '@colonist/game-card-types'

export abstract class BaseCardValidator<CardStateType extends CardStateOrdered | CardStateUnordered> {
    abstract get cards(): CardEnum[]

    protected readonly state: CardStateType

    constructor(state: CardStateType) {
        this.state = state
    }

    hasCardsInInventory(cardEnums: CardEnum[]): boolean {
        const uniqueCardEnums = ArrayUtils.removeDuplicatesFromArray(cardEnums)
        for(const uniqueCard of uniqueCardEnums) {
            const amountInInventory = ArrayUtils.countOccurenceOfValueInArray(this.cards, uniqueCard)
            const amountRequested = ArrayUtils.countOccurenceOfValueInArray(cardEnums, uniqueCard)
            if(amountInInventory < amountRequested) return false
        }
        return true
    }

    getCardsOfType(cardType: CardTypeEnum): CardEnum[] {
        const cardsOfType: CardEnum[] = []
        for(const card of this.cards) {
            const cardData = CardDataController.getCardDataForCard(card)
            if(cardData == undefined) continue
            if(cardData.cardTypeEnum != cardType) continue

            cardsOfType.push(card)
        }
        return cardsOfType
    }

    hasCardOfType(cardType: CardTypeEnum): boolean {
        for(const card of this.cards) {
            const cardData = CardDataController.getCardDataForCard(card)
            if(cardData == undefined) continue

            if(cardData.cardTypeEnum == cardType) return true
        }
        return false
    }

    getNumberOfCardsInInventory(): number {
        return this.cards.length
    }

    getCardCountOfType(cardType: CardTypeEnum): number {
        return this.getCardsOfType(cardType).length
    }

    getCardCountForCard(cardEnum: CardEnum): number {
        return ArrayUtils.countOccurenceOfValueInArray(this.cards, cardEnum)
    }
}
